var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0745 1.75768C16.8004 1.63333 16.4986 1.60065 16.2074 1.66379C15.9163 1.72693 15.6489 1.88303 15.4395 2.11223L13.5 4.2248L10.0605 0.478371C9.77921 0.17207 9.39775 0 9 0C8.60225 0 8.22079 0.17207 7.9395 0.478371L4.5 4.2248L2.5605 2.11223C2.35072 1.8838 2.08348 1.72824 1.79255 1.66523C1.50162 1.60222 1.20007 1.63457 0.926018 1.75821C0.651968 1.88184 0.417724 2.0912 0.252898 2.35982C0.0880711 2.62845 6.33365e-05 2.94427 0 3.26736L0 11.9154C0.00119089 12.9983 0.396661 14.0365 1.09966 14.8022C1.80267 15.5679 2.7558 15.9987 3.75 16L4.35644 15.9411C7.44487 15.6409 10.5551 15.6409 13.6436 15.9411L14.25 16C15.2442 15.9987 16.1973 15.5679 16.9003 14.8022C17.6033 14.0365 17.9988 12.9983 18 11.9154V3.26736C18.0001 2.94424 17.9122 2.62835 17.7475 2.35963C17.5827 2.09091 17.3485 1.88144 17.0745 1.75768Z",
    fill: "#F9A72E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.bf61dce00ce50c0d805884acd5f7b2ee.svg";
export { ForwardRef as ReactComponent };